import React from 'react';
import { Img, Text, Button } from '../../Atoms';
import affiliationLogo from '../../assets/img/affiliation-logo.png';

function OrganismAffiliationGardePage (props) {
  return (
    <div className='affiliation-content-container'>
      <div className='affiliation-content-img-container'>
        <Img
          src={affiliationLogo}
          className='affiliation-content-img affiliation-radius'
        />
      </div>
      <div className='affiliation-content-info-container'>
        <div>
          <Text
            text='Bonjour Alba,'
            className='affiliation-content-info-text-bold affiliation-content-info-text-margin'
          />
          <Text
            text='Bienvenue chez SPVIE Assurances!'
            className='affiliation-content-info-text-bold'
          />
          <Text
            text='Adhérez à la complémentaire santé de votre entreprise et découvrez par la suite votre Espace Assuré.'
            className='affiliation-content-info-text affiliation-context-info-text-container'
          />
          <Button
            text='Je commence l’affiliation'
            className='affiliation-content-info-button'
            onClick={props.beginAffiliationClicked}
            boxShadow
          />
          <Button
            text='Je bénéficie d’un cas de dispense'
            className='affiliation-content-info-button'
            onClick={props.dispenseClicked}
            boxShadow
          />
          <Button
            text='Je souhaite voir les garanties'
            className='affiliation-content-info-button'
            boxShadow
          />
        </div>
      </div>
    </div>
  );
}

export default OrganismAffiliationGardePage;
